<script lang="ts" setup>
import { useTemplateRef } from 'vue'
import { useBrxmData } from '../../composables/useBrxmData'
import FaqAndDocsContent from './parts/FaqAndDocsContent.vue'
import type { IDocs, IFaq } from './types'
import type { IBrxmProps } from '@/cms-ui/ts/interfaces/IBrxmProps'
import type { ITabItem } from '@/ui/plushComponents/VTabs/types'
import { useVisibilityTracking } from '@/cms-ui/composables/useAnalytics'

const props = defineProps<IBrxmProps>()
const data = useBrxmData(props, 'FAQ_AND_DOCS')
const { faqOrDocsGroup, darkmode, name } = data.value
const faqAndDocsRef = useTemplateRef('faqAndDocsRef')

useVisibilityTracking(faqAndDocsRef, 'FaqAndDocs', name || 'FaqAndDocs')

const tabs = faqOrDocsGroup.map((item: { title: string; faq: IFaq; docs: IDocs[] }) => ({
    name: item?.title,
    value: item?.title?.replaceAll(' ', '_'),
    content: {
        faq: { ...item?.faq, items: item?.faq?.items?.map(item => ({ ...item, isOpen: false })) },
        docs: item?.docs,
    },
}))

const active = faqOrDocsGroup[0].title?.replaceAll(' ', '_')
</script>

<template>
    <section
        ref="faqAndDocsRef"
        class="space-standard container"
    >
        <VTabs
            v-if="tabs?.length > 1"
            :data-test="`faq-and-docs_${name}`"
            size="LARGE"
            layout="hug"
            :tabs-list="tabs"
            :list-aria-label="`faq-and-docs_${name}`"
            :dark="darkmode"
            :default-value="active"
        >
            <template #default="{ activeSlide }">
                <VTabsAnimation>
                    <template v-if="tabs?.length">
                        <VTabsContent
                            v-for="tab in tabs?.filter((tab: ITabItem) => activeSlide === tab.value)"
                            :key="tab.value"
                            :value="tab.value"
                            class="mt-6"
                        >
                            <FaqAndDocsContent
                                :content="tab.content"
                                :darkmode="darkmode"
                            />
                        </VTabsContent>
                    </template>
                </VTabsAnimation>
            </template>
        </VTabs>
        <div v-else>
            <template v-if="tabs.length === 1">
                <FaqAndDocsContent
                    :content="tabs[0].content"
                    :darkmode="darkmode"
                />
            </template>
        </div>
    </section>
</template>

<style scoped>
.fade-in-out{transition:opacity .5s ease-in-out}.fade-in-out-enter-active,.fade-in-out-leave-active{opacity:1}.fade-in-out-enter,.fade-in-out-leave-to{opacity:0}
</style>
